import CouponError from './CouponsError';
class CouponNotEnoughBricksAvailable extends CouponError {
    couponId;
    propertyId;
    constructor(couponId, propertyId, options) {
        super('The number of bricks exceeds the bricks available of the Crowdfunding Property', options);
        this.couponId = couponId;
        this.propertyId = propertyId;
    }
}
export default CouponNotEnoughBricksAvailable;
